import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { AppSettings } from '../../entities/AppSettings';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
    private settingsUrl = '/api/config/appSettings';
    public AppSettings: {}
  constructor(private http: HttpClient) { }

  getConfig(): Observable<object[]> {
    return this.http.get<any>(this.settingsUrl)
      .pipe(
        catchError(this.handleError('getConfig', []))
      );
  }

  post(url: string, object: any): Observable<any> {
    return this.http.post<any>(url, object)
      .pipe(
        tap(heroes => this.log(`post item`)),
        catchError(this.handleError('post', []))
      );
  }

  getItem(url: string): Observable<any> {
    return this.http.get<any>(url);
  }

  private log(message: string) {
    //this.messageService.add('ApiService: ' + message);
  }

  /**
* Handle Http operation that failed.
* Let the app continue.
* @param operation - name of the operation that failed
* @param result - optional value to return as the observable result
*/
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
